/**************************************************
 * Nombre:       Formulario_Mayorista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    ApartmentOutlined,
    Flag,
    PhoneAndroidOutlined,
    StoreMallDirectoryOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSMAYORISTAS} from "../../Constantes";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";

const Formulario_Mayorista = ({...props}) => {


    const click = () => {
        iniciarChatWass({
            mensaje: 'Hola ' + props.props.getValues('nombre'), numero: props.props.getValues('celular')
        })
    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSMAYORISTAS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Ciudad'} dato={'ciudad'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={StoreMallDirectoryOutlined} nombre={'Nombre negocio'}
                                  dato={'negocio'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTextoBoton Icono={PhoneAndroidOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                       click={click}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={6} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={6} nombre={'Notas internas'} dato={'notas'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Mayorista